export const useCache = () => {
  const dispatchCacheClear = () => {
    window.dispatchEvent(new CustomEvent("clearAllCache"));
  };

  return { dispatchCacheClear };
};
